import {TextFieldTheme} from 'wix-ui-tpa/cssVars'
import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {textEnumMetadata} from '../../../utils/builderMetadata'

export type FormSettingsParams = {
  textFieldTheme: SettingsParamType.String
}

export const formSettingsParams = createSettingsParams<FormSettingsParams>({
  textFieldTheme: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextFieldTheme.Box,
    metadata: textEnumMetadata(
      {defaultValue: TextFieldTheme.Box},
      'Style of the form fields: box = boxed fields, line = underlined fields',
    ),
  },
})
